import { render, staticRenderFns } from "./Step3-1.vue?vue&type=template&id=079c5692&scoped=true&"
import script from "./Step3-1.vue?vue&type=script&lang=js&"
export * from "./Step3-1.vue?vue&type=script&lang=js&"
import style0 from "./Step3-1.vue?vue&type=style&index=0&id=079c5692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c5692",
  null
  
)

export default component.exports